module.exports = __webpack_public_path__ + "1.5.0-unryo/img/nagios.5218b403.png";